import Notification from '../../core/Notification';
import PropTypes from 'prop-types';
import React from 'react';
import DataDownload from '../DataDownload';
import Grid from '@material-ui/core/Grid';
import withGS from '../withGShoc';
import { Typography } from '@material-ui/core';
import VersionWarning from '../VersionWarning';

class ProjectExport extends React.Component {

    render() {

        const { id, data, graph, exportName, projectType } = this.props;

        if (data.isVersionOfProject) return <VersionWarning/>;
        if (projectType && projectType !== data.type) return <Notification text="You are trying to view an incorrect project type."/>;

        return (
            <Grid container spacing={2}>
                {
                    data.ontologyProjectAssociation &&
                    <Grid item xs={12}>
                        <Typography data-test="associated-download-warning" variant="body2" paragraph>This project has associated ontology projects. By downloading the project you will also include the association information. Please note that to re-import this project you will first need to ensure any associated ontology projects are available.</Typography>
                    </Grid>
                }
                <Grid item xs={12} sm={6} lg={4}>
                    <DataDownload
                        title="Project"
                        graph={graph}
                        resource={id}
                        exportName={exportName}
                        message="Includes data for all components in a project and information about the project itself." />
                </Grid>
            </Grid>
        );
    }
}

ProjectExport.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    projectType: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired
};

export default withGS(ProjectExport);